<template>
    <component :is="tag" :class="classes">
        <slot></slot>
    </component>
</template>

<script setup>
    const pathTools = usePathTools();

    const props = defineProps({
        cover: {
            default: false,
            type: Boolean,
        },
        getcolor: {
            default: false,
            type: Boolean,
        },
        tag: {
            default: 'h1',
            type: String,
        },
    });

    const classes = computed(() => {
        let classes = [];
        if (props.cover)
            classes.push('w-full border-b-2 border-grey-light text-grey-light mb-6 mt-6');
        if (props.getcolor) 
            classes.push('text-'+ pathTools.colorAccent());
            
        /*else
            switch (this.tag) {
                case 'h1':
                    classes.push('text-4xl');
                    break;
            }*/

        return classes.join(' ');
    })

</script>
